import { Modal } from "react-native";
import { rideAtom } from "../atoms";
import { useAtom } from "jotai";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Text, View, XStack } from "tamagui";
import { HeaderButton } from "../../design-system/Button/HeaderButton";
import { ArrowLeftIcon } from "../../design-system/icons";
import { useState } from "react";
import { debounce } from "lodash";
import { RoutesList } from "./RouteList";
import { useSyncStravaRoutes } from "../../../features/Strava/hooks/useSyncStravaRoutes";
import { Input } from "../../design-system";
import { RefreshCcw } from "@tamagui/lucide-icons";
import { useApiQueryClient, useApiPost } from "../../../../lib/api";
import { Calendar } from "@tamagui/lucide-icons";

type RouteModalProps = {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
};

export const RouteModal = ({ isOpen, onClose, userId }: RouteModalProps) => {
  const [ride, setRide] = useAtom(rideAtom);

  const [searchTerm, setQuery] = useState("");

  const setDebounceSearchTerm = debounce(setQuery, 500);

  const queryClient = useApiQueryClient();

  const refreshQuery = () => {
    queryClient.invalidateQueries({ queryKey: ["routes", userId] });
  };

  const [syncStravaRoutes, isSyncing] = useSyncStravaRoutes(refreshQuery);

  const { mutate: syncStravaDates, isPending: isSyncingDates } = useApiPost<unknown, void>(
    "/api/v1/routes/sync-strava-dates",
    { onSuccess: refreshQuery }
  );

  const { top } = useSafeAreaInsets();
  return (
    <Modal
      visible={isOpen}
      animationType="fade"
      transparent={false}
      onRequestClose={onClose}
    >
      <View flex={1} paddingTop={top} bg="$brandParchment">
        <View px="$4" justifyContent="flex-start" alignItems="flex-start">
          <XStack
            justifyContent="space-between"
            w="100%"
            mb="$5"
            alignItems="flex-start"
          >
            <HeaderButton onPress={() => onClose()}>
              <ArrowLeftIcon color="black" width={16} height={16} />
            </HeaderButton>
            <XStack justifyContent="flex-end" alignItems="flex-start" gap="$2">
              <HeaderButton onPress={() => syncStravaDates()} disabled={isSyncingDates}>
                <Calendar color="black" width={16} height={16} />
              </HeaderButton>
              <HeaderButton onPress={() => syncStravaRoutes()}>
                <RefreshCcw color="black" width={16} height={16} />
              </HeaderButton>
            </XStack>
          </XStack>
        </View>

        <Text
          fontSize={16}
          fontFamily="$heading"
          textTransform="uppercase"
          pl="$4"
        >
          Select a Route
        </Text>

        <View p="$4" gap="$3">
          <Input
            placeholder="Search Routes"
            onChangeText={setDebounceSearchTerm}
          />
        </View>
        <RoutesList
          profileId={userId}
          searchTerm={searchTerm}
          isSyncing={isSyncing}
          onRefresh={refreshQuery}
          onRoutePress={(route) => {
            setRide({
              ...ride,
              route: {
                name: route.node.name ?? "",
                id: route.node.id,
              },
            });
            onClose();
          }}
        />
      </View>
    </Modal>
  );
};
